(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-klaviyo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REVISION = '2026-07-15';
    var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
    var STANDARD = ['first_name', 'last_name', 'email'];

    function setStatus(form, message, isError) {
      var status = form.querySelector('[data-klaviyo-status]');
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('NewsletterKlaviyo__Status--error', !!isError);
      status.hidden = false;
    }

    // A iscrizione riuscita il pannello di conferma prende il posto del form.
    // Il focus va spostato: il form da cui l'utente arriva sparisce, e senza
    // questo il focus tornerebbe al body, perdendo il punto nella pagina.
    function showSuccess(form) {
      var panel = form.parentElement && form.parentElement.querySelector('[data-klaviyo-success]');

      // Titolo e descrizione sono entrambi svuotabili dal theme editor. In quel caso
      // il pannello non viene reso e sostituire il form lascerebbe il vuoto: si torna
      // al messaggio inline.
      if (!panel) {
        setStatus(form, form.getAttribute('data-msg-success'), false);
        return;
      }

      form.hidden = true;
      panel.hidden = false;
      panel.focus();
    }

    function normalizePhone(value, prefix) {
      var cleaned = value.replace(/[^\d+]/g, '');
      if (!cleaned) return '';
      if (cleaned.charAt(0) === '+') return cleaned;
      return (prefix || '') + cleaned.replace(/^0+/, '');
    }

    function collect(form) {
      var attributes = {};
      var properties = {};

      form.querySelectorAll('[data-kl-field]').forEach(function (input) {
        var value = input.value.trim();
        if (!value) return;

        var key = input.getAttribute('data-kl-field');
        var property = input.getAttribute('data-kl-property');

        if (key === 'phone') {
          var phone = normalizePhone(value, form.getAttribute('data-phone-prefix'));
          if (phone) attributes.phone_number = phone;
          return;
        }

        if (property) {
          properties[property] = value;
          return;
        }

        if (STANDARD.indexOf(key) !== -1) attributes[key] = value;
      });

      if (Object.keys(properties).length) attributes.properties = properties;

      var locale = form.getAttribute('data-locale');
      if (locale) attributes.locale = locale;

      var subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
      var sms = form.querySelector('[data-kl-sms-consent]');
      if (sms && sms.checked && attributes.phone_number) {
        subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
      }
      attributes.subscriptions = subscriptions;

      return attributes;
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-klaviyo-subscribe]');
      if (!form) return;

      event.preventDefault();

      if (form.getAttribute('data-state') === 'loading') return;

      // Selezione per data attribute, non per `name`: il nome del campo puo' cambiare
      // senza rompere il controllo. Il guard sul null evita che un trap assente faccia
      // morire l'handler con un TypeError - un altro modo di non fare niente in silenzio.
      var trap = form.querySelector('[data-kl-trap]');
      if (trap && trap.checked) {
        // Scartare in silenzio e' voluto verso i bot, ma senza una traccia un falso
        // positivo e' introvabile: e' costato una sessione di debug.
        console.warn('[newsletter-klaviyo] invio scartato: honeypot spuntato.');
        return;
      }

      var payloadAttributes = { profile: { data: { type: 'profile', attributes: collect(form) } } };
      var customSource = form.getAttribute('data-custom-source');
      if (customSource) payloadAttributes.custom_source = customSource;

      form.setAttribute('data-state', 'loading');

      fetch(ENDPOINT + '?company_id=' + encodeURIComponent(form.getAttribute('data-company-id')), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: REVISION
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: payloadAttributes,
            relationships: {
              list: { data: { type: 'list', id: form.getAttribute('data-list-id') } }
            }
          }
        })
      })
        .then(function (response) {
          if (response.status !== 202) throw new Error('HTTP ' + response.status);
          form.reset();
          showSuccess(form);
        })
        .catch(function () {
          setStatus(form, form.getAttribute('data-msg-error'), true);
        })
        .then(function () {
          form.removeAttribute('data-state');
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
